import React from 'react';
import OrgLogoNameWidget from './OrgLogoNameWidget';
import OrgIndicatorsWidget from './OrgIndicatorsWidget';
import OrgSDGPieWidget from './OrgSDGPieWidget';
import OrgIndicatorsPerSDG from './OrgIndicatorsPerSDG';
import OrgPlansWidget from './OrgPlansWidget';
import ORGANIZATION_SDGS_PIECHART_Widget from './ORGANIZATION_SDGS_PIECHART_Widget';
import ORGANIZATION_AUE_PIECHART_Widget from './ORGANIZATION_AUE_PIECHART_Widget';
import ORGANIZATION_LOGO_NAME_Widget from './ORGANIZATION_LOGO_NAME_Widget';
import ORGANIZATION_AREA_INDICATORS_Widget from './ORGANIZATION_AREA_INDICATORS_Widget';


const OrganizationWidgetFactory = ({ widget, atPublicDashboard = false, password = null }) => {
    switch (widget.widgetConfig.acronym) {
        // B2B WIDGETS for CUSTOM DASHBOARDS
        case 'ORGANIZATION_LOGO_NAME_WIDGET':
            return <OrgLogoNameWidget widget={widget} />;
        case 'ORGANIZATION_GREEN_INDICATORS_WIDGET':
            return <OrgIndicatorsWidget widget={widget} status='GREEN' />;
        case 'ORGANIZATION_YELLOW_INDICATORS_WIDGET':
            return <OrgIndicatorsWidget widget={widget} status='YELLOW' />;
        case 'ORGANIZATION_RED_INDICATORS_WIDGET':
            return <OrgIndicatorsWidget widget={widget} status='RED' />;
        case 'ORGANIZATION_GREY_INDICATORS_WIDGET':
            return <OrgIndicatorsWidget widget={widget} status='NO_STATUS' />;
        case 'ORGANIZATION_SDGS_PIECHART_WIDGET':
            return <OrgSDGPieWidget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        case 'ORGANIZATION_INDICATORS_PER_SDG_WIDGET':
            return <OrgIndicatorsPerSDG widget={widget} />;
        case 'ORGANIZATION_PLANS_WIDGET':
            return <OrgPlansWidget widget={widget} />;
        // CUSTOMER WIDGETS
        case 'ORGANIZATION_SDGS_PIECHART':
            return <ORGANIZATION_SDGS_PIECHART_Widget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        case 'ORGANIZATION_AUE_PIECHART':
            return <ORGANIZATION_AUE_PIECHART_Widget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        case 'ORGANIZATION_LOGO_NAME':
            return <ORGANIZATION_LOGO_NAME_Widget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        case 'ORGANIZATION_AREA_INDICATORS':
            return <ORGANIZATION_AREA_INDICATORS_Widget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        default:
            return <div>Unknown organization widget type</div>;
    }
};

export default OrganizationWidgetFactory;